import { format } from "date-fns";
import { Eraser, Search } from "lucide-react";
import React, { useState } from "react";
import { FiltrosLegislation } from "../types";
import { DatePicker } from "./DatePicker";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

interface LegislationFiltersProps {
  onApplyFilters: (filters: FiltrosLegislation) => void;
}

const LegislationFilters: React.FC<LegislationFiltersProps> = ({
  onApplyFilters,
}) => {
  const [fromDate, setFromDate] = useState<Date | undefined>(undefined);
  const [toDate, setToDate] = useState<Date | undefined>(undefined);
  const [searchText, setSearchText] = useState<string>("");

  // Manejar el envío del formulario
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const filters: FiltrosLegislation = {};

    // Añadir fechas si están definidas
    if (fromDate) {
      filters.from_date = format(fromDate, "yyyy-MM-dd");
    }

    if (toDate) {
      filters.to_date = format(toDate, "yyyy-MM-dd");
    }

    // Añadir texto de búsqueda si está definido
    if (searchText.trim()) {
      filters.search_text = searchText.trim();
    }

    onApplyFilters(filters);
  };

  // Limpiar todos los filtros
  const handleClearFilters = () => {
    setFromDate(undefined);
    setToDate(undefined);
    setSearchText("");
    onApplyFilters({});
  };

  // Funciones para manejar los cambios de fecha
  const handleFromDateChange = (date: Date | null) => {
    setFromDate(date || undefined);
  };

  const handleToDateChange = (date: Date | null) => {
    setToDate(date || undefined);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Filtro de texto */}
        <div className="space-y-2">
          <Label htmlFor="searchText">Texto a buscar</Label>
          <Input
            id="searchText"
            placeholder="Buscar en legislación consolidada"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>

        {/* Filtro de fecha desde */}
        <div className="space-y-2">
          <Label htmlFor="fromDate">Fecha desde</Label>
          <DatePicker
            date={fromDate}
            setDate={handleFromDateChange}
            placeholder="Seleccionar fecha inicial"
          />
        </div>

        {/* Filtro de fecha hasta */}
        <div className="space-y-2">
          <Label htmlFor="toDate">Fecha hasta</Label>
          <DatePicker
            date={toDate}
            setDate={handleToDateChange}
            placeholder="Seleccionar fecha final"
          />
        </div>
      </div>

      {/* Botones de acción */}
      <div className="flex justify-end space-x-2">
        <Button type="button" variant="outline" onClick={handleClearFilters}>
          <Eraser className="h-4 w-4 mr-2" />
          Limpiar filtros
        </Button>
        <Button type="submit">
          <Search className="h-4 w-4 mr-2" />
          Buscar
        </Button>
      </div>
    </form>
  );
};

export default LegislationFilters;
